import PropTypes from 'prop-types';
import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/styles';


const useStyles = makeStyles(() => ({
  formControl: {
    marginTop: 20,
    width: '100%'
  },
}));

const CheckboxField = ({
  children, id, label,
  input: { name, value, onChange },
  meta: { touched, error, warning },
  ...restProps
}) => {
  const classes = useStyles();

  return (
    <FormControl className={classes.formControl}>
      <FormControlLabel
        control={
          <Checkbox
            checked={!!value}
            onChange={onChange}
            value={value}
            {...restProps}
          />
        }
        label={label}
      />
    </FormControl>
  );
};

CheckboxField.propTypes = {
  children: PropTypes.node, //#TODO not used, could be removed
  id: PropTypes.string.isRequired,
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
  }).isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool.isRequired,
    warning: PropTypes.string,
  }).isRequired,
};

export default CheckboxField;
